import React from "react";
import withLocalization from "../../../hoc/with-localization";
const PrmTableTransZone = props => {
    const { transZone, indexSokolovLyon, loc, needIntervals } = props;
    let zoneVal = transZone?.val;
    if (zoneVal === undefined) zoneVal = "";
    else if (zoneVal === "Undefined")
        //  "Undefined" is a real value (not undefined)
        zoneVal = loc("report.vals.transZone_Undefined");

    if (zoneVal === "V1") zoneVal = "<" + zoneVal;
    if (zoneVal === "V6") zoneVal = ">" + zoneVal;
    let indSokolVal = indexSokolovLyon?.val;
    if (indSokolVal === undefined) indSokolVal = "";

    return (
        <table className="prm-table prm-table-trans-zone">
            <tbody>
                <tr>
                    <td className="prm-title">{loc("report.params.transZone")}</td>
                    <td className="prm-data">{needIntervals && zoneVal}</td>
                </tr>
                <tr>
                    <td className="prm-title">{loc("report.params.indexSokolovLyon")}</td>
                    {needIntervals ? (
                        <td className="prm-data">
                            {indSokolVal} {loc(".units.mV")}
                        </td>
                    ) : (
                        <td className="prm-data"></td>
                    )}
                </tr>
            </tbody>
        </table>
    );
};

export default withLocalization(PrmTableTransZone);
